import type { FC } from 'react';
import { Session } from '@/components/sessions/session/index.tsx';

export const SessionDetailPage: FC = () => <Session />;
